import * as swal from 'sweetalert';
import {AccountService} from "../../../account/core/services/AccountService";
export class HeaderComponent implements ng.IComponentOptions {
    public controller: any = HeaderController;
    public bindings: any = {
      navigation: '<'
    }
    public template: string = /*html*/`
    <!-- Global Site Tag (gtag.js) - Google Analytics -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-106556838-2"></script>
    <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments)};
    gtag('js', new Date());

    gtag('config', 'UA-106556838-2');
    </script>
      <nav class="navbar">
          <div class="nav-top-bar">
            <div class="container container-fluid">
            <span class="slogan"><strong>LMIDW : Your Gateway to Labour Market Information</strong></span>
            <div class="pull-right">
              <nav class="account">
                <ul class="nav side-content">
                  <li><a href="http://www.ilmia.gov.my/index.php/en/dashboard-datamart" target="_blank"><i class="fa fa-area-chart fa-fw"></i>LMIDW Dashboard</a></li>
                  <li><a href="http://www.ilmia.gov.my" target="_blank"><i class="fa fa-bookmark fa-fw"></i>ILMIA Website</a></li>
                  <li ng-if="($ctrl.account.usertype === 'admin'||$ctrl.account.usertype === 'internal')&&$ctrl.token" class="dropdown" uib-dropdown>
                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="download"><i class="fa fa-download fa-fw"></i> Download&nbsp;<b class="caret"></b></a>
                    <ul class="dropdown-menu" role="menu" uib-dropdown-menu aria-labelledby="download">
                      <li><a ng-href="{{'/downloadStatic?docName='+$ctrl.docs['dpm'].name+'&docMime='+$ctrl.docs['dpm'].mime+'&docPath='+$ctrl.docs['dpm'].path+'&token='+$ctrl.token}}" class="download-static" target="_blank">Data Provider Manual</a></li>
                      <li class="nav-divider"><a href="">  ------ </a></li>
                      <li><a ng-href="{{'/downloadStatic?docName='+$ctrl.docs['sopdoc'].name+'&docMime='+$ctrl.docs['sopdoc'].mime+'&docPath='+$ctrl.docs['sopdoc'].path+'&token='+$ctrl.token}}" class="download-static" target="_blank">SOP Documentation</a></li>
                      <li class="nav-divider"><a href="">  ------ </a></li>
                      <li><a ng-href="{{'/downloadStatic?docName='+$ctrl.docs['drf'].name+'&docMime='+$ctrl.docs['drf'].mime+'&docPath='+$ctrl.docs['drf'].path+'&token='+$ctrl.token}}" class="download-static" target="_blank">Data Request Form</a></li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
            </div>
          </div>
          <div class="nav-lower-bar">
            <div class="container container-fliud" style="height:100%">
                <div class="navbar-header" style="height:100%">
                    <a class="navbar-brand" href="#/"><img src=${TARGET==='public'?require("../../../../images/dfms-logo.png"):require("../../../../images/dfms-logo-admin.jpeg")} /></a>
                </div>
            </div>
          </div>
          <section ng-show="$ctrl.navigation">
               <nav id="nav" class="navbar navbar-default navbar-main" role="navigation">
               	<div class="container" ng-init="isNavCollapsed=true">
               		<div class="navbar-header">
               		<button type="button" class="navbar-toggle" ng-click="isNavCollapsed = !isNavCollapsed">
               		<span class="sr-only">Toggle navigation</span>
               		<span class="icon-bar"></span>
               		<span class="icon-bar"></span>
               		<span class="icon-bar"></span>
               		</button>
               		</div>
               		<div class="collapse navbar-collapse" uib-collapse="isNavCollapsed">
               			<ul class="nav navbar-nav">
                      <li>
                        <div class="input-group"  ng-show="!$ctrl.account.fullname||$ctrl.account.usertype === 'external'">
                        <input type="text" class="form-control" placeholder="Search Datasets" ng-model="$ctrl.searchText" ng-enter="$ctrl.search()">
                        <span class="input-group-btn">
                        <button class="btn btn-primary" type="button" ng-click="$ctrl.search()">Search</button>
                        </span>
                        </div>
                      </li>
                      ${TARGET==='public'?'':
               				`<li ng-show="$ctrl.account.fullname&&$ctrl.account.isAdmin"><a href="#/admin"><i class="fa fa-fw fa-wrench"></i>Administration</a></li>
                        <li ng-show="$ctrl.account.usertype === 'admin'||$ctrl.account.usertype === 'internal'"><a href="#/dashboard"><i class="fa fa-dashboard fa-fw"></i>Dashboard</a></li>
                        <li ng-hide="!$ctrl.account.fullname||$ctrl.account.isAdmin||$ctrl.account.usertype === 'external'"><a href="#/mydataset"><i class="fa fa-tasks fa-fw"></i>My Datasets</a></li>`
                      }
               				<li ng-show="$ctrl.account.fullname&&$ctrl.account.usertype !== 'external'"><a href="#/search"><i class="fa fa-search fa-fw"></i>Explore Datasets</a></li>
                      ${TARGET==='public'?'': 
                       `<li ng-if="$ctrl.account.isAdmin"><a ng-click=$ctrl.addDataset()>Add Dataset</a></li>`
                      }
               			</ul>
                    <ul class="nav navbar-nav navbar-right" >
                      ${TARGET==='public'?'':
                        `<li ng-show="$ctrl.account.fullname&&!$ctrl.account.isAdmin"><a href="#/feedback"><i class="fa fa-comment fa-fw"></i>Helpdesk</a></li>`
                      }
                      <li ng-hide="$ctrl.account.fullname"><a href="#/login">Login</a></li>
                      ${TARGET==='public'?
                        `<li ng-hide="$ctrl.account.fullname"><a href="#/register">Register</a></li>`:''
                      }
                      <li ng-show="$ctrl.account.fullname" class="dropdown" uib-dropdown>
                        <a class="dropdown-toggle" uib-dropdown-toggle href="" id="profile"><i class="fa fa-user fa-fw"></i> Profile&nbsp;<b class="caret"></b></a>
                        <ul class="dropdown-menu" role="menu" uib-dropdown-menu aria-labelledby="profile">
                          <li><a href="#/profile"> Edit Profile Details</a></li>
                          <li ng-show="$ctrl.account.fullname&& ($ctrl.account.isAdmin || $ctrl.account.usertype == 'internal')"><a target="_blank" href="http://helpdesk.ilmia.gov.my:81/eApps/login/LoginAccount/loginChkAuto.do?sig=nCo5dbKTKCzrESV7ODlLsDjHGo2FvcHBnvR0Ot4M5F0=&userId={{ $ctrl.account.email }}"> Login Helpdesk</a></li>
                          <li class="nav-divider"><a href="">  ----- </a></li>
                          <li><a ng-click="$ctrl.logout()">Logout </a></li>
                        </ul>
				              </li>
                    </ul>
		            </div>
	            </div>
            </nav>
        </section>
        </nav>
    `;
}
export class HeaderController {
  public static $inject: Array<string> = ["AccountService", "$location", "$rootScope", "$uibModal", "$window", "$state"];
  public route: string;
  public searchText: string;
  public token: string;
  public navigation: boolean;
  public docs = {
    'dpm': {
      'name': 'Data-Provider-Manual.pdf',
      'mime': 'application/pdf',
      'path': require('../../../../docs/DFMS-UserManual-DataProvider-v2.1.pdf')
    },
    'sopdoc': {
      'name': 'SOP-Documentation.pdf',
      'mime': 'application/pdf',
      'path': require('../../../../docs/SOP-Documentation.pdf')
    },
    'drf': {
      'name': 'Data-Request-Form.pdf',
      'mime': 'application/pdf',
      'path': require('../../../../docs/Data-Request-Form.pdf')
    }
  };

  constructor(public account: AccountService, private $location: ng.ILocationService, private $rootScope: ng.IRootScopeService, private $uibModal: ng.ui.bootstrap.IModalService, private $window: ng.IWindowService, private $state: ng.ui.IStateService) {
    $rootScope.$on("$stateChangeSuccess", (ev, d) => {
      this.route = d.name.split('.')[0];
    })
    account.$promise.then(() => {
      this.token = account.token;
    })
  }
  public logout() {
    this.account.logout();
    // this.$location.path("/login");
  }
  public search() {
    this.$state.go('search',{q: JSON.stringify({q:this.searchText})}, {reload: true});
  }

  public addDataset() {
    let _modal = this.$uibModal.open({
      backdrop: 'static',
      keyboard: false,
      component: 'datasetModal'
    })
    _modal.result.then((result) => {
      swal({
        title: "Thank You",
        text: "Your Dataset has been uploaded",
        type: "info"}, () => {
          this.$window.open(`#/dataset/${result._id}`, '_top');
        });
    })
  }
}
